import React from "react";
import style from "./index.module.scss";

const CardReview = (porps) => {
  const post = porps.post;
  return (
    <div className={style["card"]}>
      <div className={style["card-inner"]}>
        <div className={style.avatar}>
          <img src={post.avatar} alt="使用者頭像"/>
        </div>
        <div className={style["card-txt"]}>
          <h2 className={style['card-title']}>{post.title}</h2>
          <p>{post.text}</p>
        </div>
        <div className="img-frame">
          <img src={post.img} alt="示意圖"/>
        </div>
        <div className={style.align}>
          <a href={post.link} className="btn btn-blue" target="_blank" rel="noreferrer noopener">READ MORE+</a>
        </div>
      </div>
    </div>
  )
};

export default CardReview;
